import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '@/providers/AuthProvider';
import { getErrorMessage } from '@/api/client';
import { Button, Input, FormField, Card, CardHeader, CardTitle, CardContent } from '@/components/ui';
import { IceCream2 } from 'lucide-react';

export default function LoginPage() {
  const { t }       = useTranslation();
  const { login }   = useAuth();
  const [username,  setUsername]  = useState('');
  const [password,  setPassword]  = useState('');
  const [error,     setError]     = useState('');
  const [loading,   setLoading]   = useState(false);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(username, password);
    } catch (err) {
      setError(getErrorMessage(err) || t('auth.invalid'));
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-4">
      <div className="w-full max-w-sm">
        {/* Logo */}
        <div className="mb-8 flex flex-col items-center gap-2">
          <IceCream2 size={40} className="text-primary" />
          <h1 className="text-2xl font-bold">MyNevada</h1>
        </div>

        <Card>
          <CardHeader>
            <CardTitle>{t('auth.title')}</CardTitle>
          </CardHeader>
          <CardContent>
            <form onSubmit={handleSubmit} className="flex flex-col gap-4" noValidate>
              <FormField label={t('auth.username')}>
                <Input
                  type="text"
                  autoComplete="username"
                  value={username}
                  onChange={e => setUsername(e.target.value)}
                  required
                  autoFocus
                />
              </FormField>

              <FormField label={t('auth.password')}>
                <Input
                  type="password"
                  autoComplete="current-password"
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                  required
                />
              </FormField>

              {error && (
                <p role="alert" className="rounded-md bg-destructive/10 px-3 py-2 text-sm text-destructive">
                  {error}
                </p>
              )}

              <Button type="submit" loading={loading} className="mt-1">
                {loading ? t('auth.loggingIn') : t('auth.login')}
              </Button>
            </form>
          </CardContent>
        </Card>

        <p className="mt-6 text-center text-xs text-muted-foreground">
          Internal use only · MyNevada Ice Cream
        </p>
      </div>
    </div>
  );
}
